<template>
    <div class="DepositInfo">
        <bv-top></bv-top>
        <van-panel :key="index" v-for="(item,index) in houseDepMobiles">
            <div slot="header" :key="payIndex" v-for="(payItem,payIndex) in payChannels">
                <van-row type="flex" justify="center" class="wireBottom" v-if="item.tallyFlag ==='N'">
                    <van-col style="color:red">房屋已经完成交存</van-col>
                </van-row>
                <van-row type="flex" justify="space-between">
                    <van-col span="10">房屋地址</van-col>
                    <van-col class="conterColor addresAlign">{{item.address}}</van-col>
                </van-row>
                <van-row type="flex" justify="space-between">
                    <van-col span="7">业主姓名</van-col>
                    <van-col class="conterColor">{{item.ownerName}}</van-col>
                </van-row>
                <van-row type="flex" justify="space-between">
                    <van-col span="7">房屋面积</van-col>
                    <van-col class="conterColor">{{item.constructArea}}㎡</van-col>
                </van-row>
                <van-row type="flex" justify="space-between">
                    <van-col span="7">交存模式</van-col>
                    <van-col class="conterColor">{{item.depositName}}</van-col>
                </van-row>
                <van-row type="flex" justify="space-between">
                    <van-col span="7">应交金额</van-col>
                    <van-col class="dueAmount">￥{{item.dueAmount}}</van-col>
                </van-row>
                <van-row class="wireTop" type="flex" justify="end" v-if="item.tallyFlag ==='Y'">
                    <van-col>
                        <van-button round type="primary" @click="payCli(payItem.apiUrl,item.houseNo,item.reqNo)">支付
                        </van-button>
                    </van-col>
                </van-row>
            </div>
        </van-panel>
    </div>
</template>

<script>
    import Top from '@/views/components/Top'
    import {houseDepositPay} from '@/api/maintainFund/maintainFund'

    export default {
        name: "DepositInfo",
        data() {
            return {
                houseDepMobiles: [],
                payChannels: [],
            }
        },
        components: {
            BvTop: Top
        },
        methods: {
            payCli: function (apiUrl, houseNo, reqNo) {
                //添加加载状态
                const toast = this.$toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '加载中...'
                });
                let second = 3;
                const timer = setInterval(() => {
                    second--;
                    if (second) {
                        toast.message = `加载中...`;
                        let param = {
                            'apiUrl': apiUrl, 'houseNo': houseNo, 'reqNo': reqNo
                        };
                        houseDepositPay(param).then(response => {
                            window.location.href = response.data.respUrl;
                        })
                    } else {
                        clearInterval(timer);
                        this.$toast.clear();
                    }
                }, 1000);
            }
        },
        mounted() {
            this.houseDepMobiles = this.$route.query.houseDepMobiles;
            this.payChannels = this.$route.query.payChannels
        }
    }
</script>

<style lang='scss'>
    .DepositInfo {
        .van-panel {
            border-bottom: 10px solid #e1e1e1;

            .van-row {
                padding: 5px 10px;
                line-height: 26px;

                .conterColor {
                    color: #969799;
                }

                .dueAmount {
                    color: red;
                }

                .van-button {
                    height: 4vh !important;
                    line-height: 0;
                }

                .addresAlign {
                    text-align: right;
                }
            }

            .wireBottom {
                border-bottom: 1px solid #f2f2f2;
            }

            .wireTop {
                border-top: 1px solid #f2f2f2;
            }
        }
    }
</style>
